import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { apiClient } from '~admin/client';
import { OneArgTask, rxTask } from '~common/helper/mobx-tasks';
import { SeatConfigurationRequest } from '~client/model/admin/seat-configuration-request';
import { SeatConfigurationResponse } from '~client/model/admin/seat-configuration-response';
import { mapSeatConfigurationData } from '~admin/model/seat-configuration-data.mapper';
import { SeatConfigurationData } from '~admin/model/seat-configuration-data';

export type CreateSeatConfigurationTask = OneArgTask<
  SeatConfigurationRequest,
  SeatConfigurationData
>;

/* Creates a new seat configuration */
export const performCreateSeatConfiguration = (
  request: SeatConfigurationRequest,
): Observable<SeatConfigurationResponse> =>
  apiClient.locationProfileAdminController.createSeatConfiguration$(request);

export const createSeatConfigurationTaskFactory = (): CreateSeatConfigurationTask =>
  rxTask<SeatConfigurationRequest, SeatConfigurationData>((request: SeatConfigurationRequest) =>
    performCreateSeatConfiguration(request).pipe(map(mapSeatConfigurationData)),
  );



// WEBPACK FOOTER //
// ./interactor/location/perform-create-seat-configuration.ts